import React from "react";
import { Link } from "react-router-dom";
import PageMeta from "../components/PageMeta";
import PageShell from "../components/PageShell";
import { Section } from "../components/MarketingPrimitives";

const ThankYouPage = () => {
  return (
    <PageShell>
      <PageMeta
        title="Thank You | BestSalesCoach.ai"
        description="Your BestSalesCoach.ai demo request has been received."
        canonicalPath="/thank-you"
      />

      <Section
        id="thank-you"
        eyebrow="Demo request received"
        title="Thanks — your demo request has been received."
        description="We’ll review your request and follow up with the next best step based on what you’re trying to improve."
        tone="hero"
      >
        <div className="marketing-card thank-you-card">
          <p className="marketing-body-copy">
            Someone will contact you by email about the available timeslots.
          </p>
          <p className="marketing-body-copy">
            If you do not hear back, please reach out to{" "}
            <a className="marketing-text-link" href="mailto:admin@bestsalescoach.ai">
              admin@bestsalescoach.ai
            </a>
            .
          </p>
          <div className="hero-actions">
            <Link className="marketing-button marketing-button-primary" to="/">
              Return to Home
            </Link>
            <Link className="marketing-button marketing-button-secondary" to="/usecases">
              Explore Use Cases
            </Link>
          </div>
          <p className="demo-form-note">
            BestSalesCoach.ai helps CROs, founders, and GTM teams improve signal-to-execution,
            pipeline quality, account strategy, and revenue execution discipline.
          </p>
        </div>
      </Section>
    </PageShell>
  );
};

export default ThankYouPage;
